import {
  AuthenticationClient,
  clearEhrAuthentication,
} from '../features/authentication/slice/authenticationSlice'
import { useAppDispatch } from '../app/typedReduxHooks'
import {
  clearWorkPrescriberProfileId,
  setPrescriber,
} from '../pages/NewScriptPage/ScriptForm/PrescriberSlice'
import {
  clearCurrentEhrAuthStorage,
  isEhrAuthSession,
} from '../features/ehr-launch/ehrLaunchStorage'
import { invalidateAuthenticatedContext } from '../features/authenticated-context/authenticatedContextSlice'
import { setOrganizationAdmin } from '../features/organization-admin/organizationAdminSlice'
import { resetAuthenticatedProvider } from '../features/authentication/slice/authenticatedProviderSlice'

type LogoutOptions =
  | { mode: 'ehr'; preserveSharedEhrSession?: boolean }
  | { mode?: 'full'; skipCognitoLogout?: boolean }

export const useLogout = () => {
  const dispatch = useAppDispatch()
  return async (options: LogoutOptions = {}) => {
    if (options.mode === 'ehr') {
      dispatch(invalidateAuthenticatedContext())
      dispatch(clearEhrAuthentication())
      dispatch(setPrescriber(null))
      dispatch(setOrganizationAdmin(null))
      dispatch(resetAuthenticatedProvider())
      dispatch(clearWorkPrescriberProfileId())
      clearCurrentEhrAuthStorage(options.preserveSharedEhrSession)
      window.history.replaceState(null, '', '/')
      window.dispatchEvent(new PopStateEvent('popstate'))
      return
    }
    const { skipCognitoLogout } = options
    const isEhrSession = isEhrAuthSession()
    const clientId = localStorage.getItem('client_id')

    dispatch(invalidateAuthenticatedContext())
    await dispatch(AuthenticationClient.Logout())
    dispatch(clearWorkPrescriberProfileId())

    if (isEhrSession || skipCognitoLogout || !clientId) {
      window.location.href = '/'
      return
    }

    const cognitoAuthUri = process.env.REACT_APP_COGNITO_AUTH_URI
    const logoutRedirectUri = process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI
    if (!cognitoAuthUri || !logoutRedirectUri) {
      window.location.href = '/'
      return
    }
    const logoutUrl = new URL('/logout', cognitoAuthUri)
    logoutUrl.searchParams.set('client_id', clientId)
    logoutUrl.searchParams.set('logout_uri', logoutRedirectUri)
    window.location.href = logoutUrl.toString()
  }
}
